import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

import { AdminMenuPrivileges } from "../privilegesProviders/AdminMenuPrivilegesProvider";
import { WorkerMenuPrivileges } from "../privilegesProviders/WorkerMenuPrivilegesProvider";
import { WorkplaceMenuPrivileges } from "../privilegesProviders/WorkplaceMenuPrivilegesProvider";
import { NavigationMenu } from "./types";
import { getAdminNavigationMenu } from "./useGetAdminNavigationMenu";
import { getWorkerNavigationMenu } from "./useGetWorkerNavigationMenu";
import { getWorkplaceNavigationMenu } from "./useGetWorkplaceNavigationMenu";

interface NavigationMenuOptions {
  unreadChannelCount?: number;
  pendingExtraWorkedTimeRequestCount?: number;
}

export function useGetNavigationMenu(
  isAdmin: boolean,
  adminMenuPrivileges: AdminMenuPrivileges,
  isWorker: boolean,
  workerMenuPrivileges: WorkerMenuPrivileges,
  isWorkplace: boolean,
  workplaceMenuPrivileges: WorkplaceMenuPrivileges,
  currentPath: string,
  options: NavigationMenuOptions = {}
): NavigationMenu {
  const analyticsConfig = useCbhFlag(CbhFeatureFlag.FACILITY_EXPLO_ANALYTICS_ENABLED, {
    defaultValue: [],
  });

  if (isAdmin) {
    return getAdminNavigationMenu(adminMenuPrivileges, currentPath);
  } else if (isWorker) {
    return getWorkerNavigationMenu(workerMenuPrivileges, currentPath);
  } else if (isWorkplace) {
    return getWorkplaceNavigationMenu(workplaceMenuPrivileges, currentPath, analyticsConfig, {
      unreadChannelCount: options.unreadChannelCount,
      pendingExtraWorkedTimeRequestCount: options.pendingExtraWorkedTimeRequestCount,
    });
  } else {
    return { items: [] };
  }
}
